<div class="section-header mb-3">Things to know</div>
<div *ngFor="let marketingCard of filteredMarketingCards">
  <common-media-object [marketingCard]="marketingCard" [indentBody]="true"></common-media-object>
</div>